import { updateWorkspace, updateWorkspaceName, updateWorkspaceDescription, getMetricTemplateAnnotations, clearAllResults, removeResultElementsWithLongCalculation, } from "../store/ps-workspace/ps-workspace.actions";
import { UPDATE_WORKSPACE_SOCKET_METHODS, } from "../store/ps-workspace/ps-workspace.update.types";
import { PsCalculationResultsDataItemState, EngineResultType, } from "../store/ps-workspace/ps-workspace.types";
export const isConfigurationComplete = (knownValues = [], bioreactorId) => knownValues.every((i) => i.value !== null) && bioreactorId !== "";
export const isMetricComplete = (metric) => metric.paramId !== null &&
    metric.templateId !== null &&
    metric.profileTemplateParameters.every((param) => param.value !== null);
export const editScenarioDescription = (dispatch, analysisId, description) => dispatch(updateWorkspace({
    method: UPDATE_WORKSPACE_SOCKET_METHODS.UpdateAnalysisDescription,
    data: { analysisId, description },
}));
export const editWorkspaceDescription = (dispatch, workspaceId, description) => dispatch(updateWorkspaceDescription({
    workspaceId,
    description,
}));
export const editWorkspaceName = (dispatch, workspaceId, name) => dispatch(updateWorkspaceName({
    workspaceId,
    name,
}));
export const updateConfigurationDescription = (dispatch, analysisId, configurationId, description) => dispatch(updateWorkspace({
    method: UPDATE_WORKSPACE_SOCKET_METHODS.UpdateConfigurationDescription,
    data: { analysisId, configurationId, description },
}));
export const updateMetricDescription = (type, dispatch, analysisId, riskId, description) => dispatch(updateWorkspace({
    method: type === "relative"
        ? UPDATE_WORKSPACE_SOCKET_METHODS.UpdateDescriptionForRelativeRiskProfile
        : UPDATE_WORKSPACE_SOCKET_METHODS.UpdateDescriptionForAbsoluteRiskProfile,
    data: { analysisId, riskId, description },
}));
export const addMetric = (dispatch, analysisId, type) => dispatch(updateWorkspace({
    method: type === "relative"
        ? UPDATE_WORKSPACE_SOCKET_METHODS.AddRelativeRiskProfileToAnalysis
        : UPDATE_WORKSPACE_SOCKET_METHODS.AddAbsoluteRiskProfileToAnalysis,
    data: { analysisId },
}));
export const renameConfiguration = (dispatch, analysisId, configurationId, name) => dispatch(updateWorkspace({
    method: UPDATE_WORKSPACE_SOCKET_METHODS.UpdateConfigurationName,
    data: {
        analysisId,
        configurationId,
        name,
    },
}));
export const addConfiguration = (dispatch, analysisId) => dispatch(updateWorkspace({
    method: UPDATE_WORKSPACE_SOCKET_METHODS.AddConfiguration,
    data: { analysisId },
}));
export const removeConfiguration = (dispatch, analysisId, configurationId) => dispatch(updateWorkspace({
    method: UPDATE_WORKSPACE_SOCKET_METHODS.RemoveConfiguration,
    data: { analysisId, configurationId },
}));
export const addResultSetElement = (dispatch, resultSetId, resultSetElementType) => dispatch(updateWorkspace({
    method: UPDATE_WORKSPACE_SOCKET_METHODS.AddResultSetElement,
    data: { resultSetId, resultSetElementType },
}));
export const removeResultSetElement = (dispatch, resultSetId, resultSetElementId, resultSetElementType) => dispatch(updateWorkspace({
    method: UPDATE_WORKSPACE_SOCKET_METHODS.RemoveResultSetElement,
    data: { resultSetId, resultSetElementId, resultSetElementType },
}));
export const removeResultSet = (dispatch, resultSetId) => {
    dispatch(updateWorkspace({
        method: UPDATE_WORKSPACE_SOCKET_METHODS.RemoveResultSet,
        data: { resultSetId },
    }));
    dispatch(removeResultElementsWithLongCalculation({ resultSetId, resultSetElementId: null, type: null }));
    dispatch(clearAllResults(resultSetId));
};
export const renameResultSet = (dispatch, resultSetId, name) => dispatch(updateWorkspace({
    method: UPDATE_WORKSPACE_SOCKET_METHODS.UpdateResultSetName,
    data: { resultSetId, name },
}));
export const editResultSetDescription = (dispatch, resultSetId, description) => dispatch(updateWorkspace({
    method: UPDATE_WORKSPACE_SOCKET_METHODS.UpdateResultSetDescription,
    data: { resultSetId, description },
}));
export const renameScenario = (dispatch, analysisId, name) => dispatch(updateWorkspace({
    method: UPDATE_WORKSPACE_SOCKET_METHODS.UpdateAnalysisName,
    data: { analysisId, name },
}));
export const addScenario = (dispatch) => dispatch(updateWorkspace({ method: UPDATE_WORKSPACE_SOCKET_METHODS.AddAnalysis }));
export const addResultSet = (dispatch) => dispatch(updateWorkspace({ method: UPDATE_WORKSPACE_SOCKET_METHODS.AddResultSet }));
export const removeScenario = (dispatch, analysisId) => dispatch(updateWorkspace({
    method: UPDATE_WORKSPACE_SOCKET_METHODS.RemoveAnalysis,
    data: { analysisId },
}));
export const renameMetric = (dispatch, analysisId, riskId, name, type) => {
    if (riskId !== null && riskId !== undefined) {
        dispatch(updateWorkspace({
            method: type === "relative"
                ? UPDATE_WORKSPACE_SOCKET_METHODS.UpdateRelativeRiskProfileName
                : UPDATE_WORKSPACE_SOCKET_METHODS.UpdateAbsoluteRiskProfileName,
            data: {
                analysisId,
                riskId,
                name,
            },
        }));
    }
};
export const removeMetric = (dispatch, method, analysisId, riskId) => dispatch(updateWorkspace({ method, data: { analysisId, riskId } }));
export const renameResultElement = (dispatch, name, type, elementPath) => {
    let method;
    switch (type) {
        case EngineResultType.Result0D:
            method = UPDATE_WORKSPACE_SOCKET_METHODS.UpdateResultSetTableElementName;
            break;
        case EngineResultType.Result1D:
            method = UPDATE_WORKSPACE_SOCKET_METHODS.UpdateResultSetLineGraphElementName;
            break;
        case EngineResultType.Result2D:
            method = UPDATE_WORKSPACE_SOCKET_METHODS.UpdateResultSetHeatMapElementName;
            break;
        case EngineResultType.ResultMetadata:
            method = UPDATE_WORKSPACE_SOCKET_METHODS.UpdateResultSetMetadataElementName;
            break;
    }
    if (method) {
        dispatch(updateWorkspace({
            method,
            data: { ...elementPath, name },
        }));
    }
};
const getDifference = (array1, array2) => array1.filter((item1) => !array2.includes(item1));
export const getNewItemId = function (oldList = [], newList = []) {
    const oldIds = oldList.map(({ id }) => id);
    const newIds = newList.map(({ id }) => id);
    const diff = getDifference(newIds, oldIds);
    return diff.length > 0 ? diff[0] : false;
};
export const getMetricGraph = (dispatch, parameters, template, units) => {
    dispatch(getMetricTemplateAnnotations({
        templateId: template ?? undefined,
        parameters: parameters.map(({ name, value, defaultValue }) => ({
            parameterId: name,
            value: value === undefined ? defaultValue : Number(value),
        })),
        unitsId: units ?? undefined,
    }));
};
export const renderTabularViewValue = (data, renderers) => {
    switch (data?.state) {
        case PsCalculationResultsDataItemState.Pending:
            return renderers.pending();
        case PsCalculationResultsDataItemState.Conflict:
            return renderers.noPossible(data);
        case PsCalculationResultsDataItemState.NoOptimum:
            return renderers.noPossible(data);
        case PsCalculationResultsDataItemState.IncompleteDependencySet:
            return renderers.noPossible(data);
        case PsCalculationResultsDataItemState.UniqueSolutions:
            return data.valuesWithConfidence?.length > 0 ? renderers.normal(data) : renderers.undefined(data);
        case PsCalculationResultsDataItemState.MultipleSolutions:
            return data.valuesWithConfidence?.length > 0 ? renderers.normal(data) : renderers.undefined(data);
        case PsCalculationResultsDataItemState.TooManyDegreesOfFreedom:
            return renderers.undefined(data);
        case PsCalculationResultsDataItemState.Undefined:
            return renderers.undefined(data);
        default:
            return [];
    }
};
